import { render, staticRenderFns } from "./CadastroContatoModal.vue?vue&type=template&id=d19e8f5c&scoped=true&"
import script from "./CadastroContatoModal.vue?vue&type=script&lang=js&"
export * from "./CadastroContatoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d19e8f5c",
  null
  
)

export default component.exports